import { throttle } from 'throttle-debounce';
import { getItemsInColumns } from '../../ts/helper';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-services"]';

/**
 * Friendation component
 */
export const blockServices = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    const container: HTMLElement = component.querySelector('.items');
    const items: HTMLLIElement[] = Array.from(
      container.querySelectorAll(':scope > li')
    );

    const onResize = throttle(300, () => {
      // reset all
      items.forEach((item) => {
        item.classList.remove('shifted');
      });

      // Only for > Tablet
      if (window.innerWidth > 768) {
        const columns = getItemsInColumns(container);

        /** Manipulate every first item in every second column, starting with the first column */
        columns.forEach((column, i) => {
          if (!(i % 2)) {
            const firstElement = column[0];
            firstElement.classList.add('shifted');
          }
        });
      }
    });

    window.addEventListener('resize', onResize);
    onResize();
  });
};
